import React from 'react';

const RightEmptyArrow: React.FC = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M6.875 3.75L13.125 10L6.875 16.25'
        stroke='#B5B5BD'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default RightEmptyArrow;
